import { useEffect, useState } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import useQuery from "../../hooks/useQuery";

import useStyles from "./scroll-top-button.styles";
import ArrowUpIcon from "../../assets/icons/arrow-up-icon";

const ScrollTopButton = () => {
  const query = useQuery();
  const matches = useMediaQuery("(min-width:1200px)");

  const [hidden, setHidden] = useState(true);
  const [isInProduct, setIsInProduct] = useState(!!query.get("productId"));

  useEffect(() => {
    setIsInProduct(!!query.get("productId"));
  }, [query.get("productId")]);

  const classes = useStyles({ hidden, matches, isInProduct });

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleScroll = () =>
    window.scrollY > 200 ? setHidden(false) : setHidden(true);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <button onClick={handleClick} className={classes.button}>
      <ArrowUpIcon width="40" height="40" />
    </button>
  );
};

export default ScrollTopButton;
